export default {
    encoding: [
        {
            name: 'x',
            type: '[time | number | string]',
            desc: 'Specify the dataSource applied to the x-axis.',
            defaultValue: 'primary[0]',
            isRequired: 'true',
        },
        {
            name: 'y',
            type: '[number | string]',
            desc: 'Specify the dataSource applied to the y-axis.',
            defaultValue: 'primary[1:]',
            isRequired: 'true',
        },
        {
            name: 'y2',
            type: '[number | string]',
            desc: `Specify the dataSource applied to the y2-axis.`,
            isRequired: 'false',
        },
    ],
    events: [
        {
            name: 'point.click',
            desc: 'trigger when user clicks a data point.',
        },
        {
            name: 'legend.click',
            desc: 'trigger when user clicks a chart legend.',
        },
    ],
};
